import {
  Boxes, CalendarCheck, ClipboardList, Columns3, Gauge, Home, LayoutGrid, MapPin, MessageSquare,
  PiggyBank, Receipt, ReceiptText, Route as RouteIcon, ScanBarcode, Settings, ShieldCheck, ShoppingCart, Tags, UserSearch, Building2, Navigation, Send, FileImage,
} from "lucide-react";

// The operator app's one menu. Add an entry here (and a route in AdminApp.jsx) for each new page.
// `end: false` keeps the item highlighted on its sub-pages.
export const NAV = [
  { items: [{ to: "/admin", label: "Home", icon: Home }] },
  {
    title: "Sales",
    items: [
      { to: "/admin/pipeline", label: "Pipeline", icon: Columns3 },
      { to: "/admin/crm", label: "Leads", icon: UserSearch },
      { to: "/admin/visits", label: "Visit Routes", icon: Navigation },
      { to: "/admin/outreach", label: "Outreach", icon: Send },
      { to: "/admin/flyers", label: "Flyers", icon: FileImage },
    ],
  },
  {
    title: "Customers",
    items: [
      { to: "/admin/service", label: "Accounts & Service", icon: Building2 },
      { to: "/admin/feedback", label: "Feedback", icon: MessageSquare },
      { to: "/admin/locations", label: "Locations & QR", icon: MapPin },
    ],
  },
  {
    title: "Stock",
    items: [
      { to: "/admin/planner", label: "Stock Overview", icon: Gauge },
      { to: "/admin/planner/machines", label: "Machines", icon: LayoutGrid, end: false },
      { to: "/admin/planner/products", label: "Products", icon: Boxes },
      { to: "/admin/planner/fill-planner", label: "Fill Planner", icon: CalendarCheck },
      { to: "/admin/planner/inventory", label: "Inventory", icon: ClipboardList },
      { to: "/admin/planner/count", label: "Count Stock", icon: ScanBarcode },
      { to: "/admin/planner/route", label: "Stocking Route", icon: RouteIcon },
      { to: "/admin/planner/shopping", label: "Shopping Lists", icon: ShoppingCart },
      { to: "/admin/planner/receipts", label: "Stock Receipts", icon: ReceiptText },
      { to: "/admin/sourcing", label: "Stock Sourcing", icon: Tags },
    ],
  },
  {
    title: "Money",
    items: [
      { to: "/admin/expenses", label: "Expenses & Mileage", icon: Receipt },
      { to: "/admin/profit-share", label: "Location Profit Share", icon: PiggyBank },
    ],
  },
  {
    title: "Settings",
    items: [
      { to: "/admin/planner/settings", label: "Planner Settings", icon: Settings },
      { to: "/admin/security", label: "Sign-in & Security", icon: ShieldCheck },
    ],
  },
];

export const ALL_ITEMS = NAV.flatMap((g) => g.items.map((i) => ({ ...i, group: g.title })));

// Breadcrumb for the top bar ("Stock / Products"): the most specific menu item matching the path.
export const crumbFor = (pathname) => {
  const path = pathname.replace(/\/$/, "") || "/admin";
  const match = ALL_ITEMS
    .filter((i) => path === i.to || path.startsWith(`${i.to}/`))
    .sort((a, b) => b.to.length - a.to.length)[0];
  return match ? [match.group, match.label].filter(Boolean) : ["Home"];
};
